import { IAddUpdateConselhoRequest } from "../../../../model/admin-portal/request/add-update-conselho-request";
import { IConselhoResponse } from "../../../../model/admin-portal/response/conselho-response";
import { IAreaTransparenciaSetorialResponse } from "../../../../model/admin-portal/response/area-transparencia-setorial-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type ConselhosState = {
    dataPaginatedListResponse: PaginationResponse<IConselhoResponse>;
    isLoadingData: boolean;
    dataResponse: IConselhoResponse | null;
    dataRequest: IAddUpdateConselhoRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    areasList: IAreaTransparenciaSetorialResponse[];
};

export const initialDataRequest: IAddUpdateConselhoRequest = {
    id: null,
    idAreaTransparenciaSetorial: null,
    nomeConselho: '',
    textoNormaCriacao: '',
    membros: [],
    atas: []
};

export const initialState: ConselhosState = {
    dataPaginatedListResponse: new PaginationResponse<IConselhoResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    areasList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setAreasList = 'setAreasList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IConselhoResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IConselhoResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateConselhoRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setAreasList; payload: IAreaTransparenciaSetorialResponse[] };

export const conselhosReducer = (state: ConselhosState, action: Action): ConselhosState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setAreasList:
            return { ...state, areasList: action.payload };
        default:
            return state;
    }
};
